import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearAuthStorage } from "@/utils";

const useLoadData = (url) => {
  const [requestedData, setRequestedData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!url) return;

    setIsLoaded(false);
    setError(null);
    setRequestedData([]);

    const fetchData = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
        };

        const response = await fetch(url, {
          headers,
          credentials: "include",
        });

        // Check if the response status is not ok (4xx or 5xx)
        if (!response.ok) {
          if (response.status === 401) {
            console.warn("Unauthorized access - redirecting to login");
            clearAuthStorage();
            localStorage.setItem(
              "redirectAfterLogin",
              location.pathname + location.search,
            );
            navigate("/login");
            return;
          }

          const errorData = await response.json().catch(() => null);
          const errorMessage =
            errorData?.message || `HTTP error! Status: ${response.status}`;
          throw new Error(errorMessage);
        }

        const response_json = await response.json();
        const data = response_json["data"];
        setRequestedData(data);
        setIsLoaded(true);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
      }
    };

    fetchData();
  }, [url, navigate, location]);

  return [requestedData, isLoaded, error];
};

export default useLoadData;
